import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'message',
    label: i18n('entities.responsibleConsumption.fields.message'),
    schema: schemas.string(
      i18n('entities.responsibleConsumption.fields.message'),
      {},
    ),
  },
  {
    name: 'images',
    label: i18n('entities.responsibleConsumption.fields.images'),
    schema: schemas.relationToMany(
      i18n('entities.responsibleConsumption.fields.images'),
      {},
    ),
  },
];